/**
 * @flow
 * @relayHash f0d33c00dc886721cd1c838bace5a468
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TrackContent_queryResult$ref = any;
export type ShopSort = "a_to_z" | "best_selling" | "discount" | "highest_rating" | "most_popular" | "nearest" | "price_asc" | "price_desc" | "z_to_a" | "%future added value";
export type TrackType = "education_park" | "health_park" | "homemade" | "shops" | "%future added value";
export type VendorFilterInput = {
  freetext_search?: ?string,
  sort?: ?ShopSort,
  coordinates?: ?LocationCoordinatesInput,
  filter?: ?$ReadOnlyArray<?ProductFilterInput>,
  page?: ?PageInfoInput,
  vendor_track_id?: ?TrackType,
  vendor_track_types?: ?$ReadOnlyArray<?TrackType>,
  track_department_ids?: ?$ReadOnlyArray<?string>,
};
export type LocationCoordinatesInput = {
  latitude?: ?number,
  longitude?: ?number,
};
export type ProductFilterInput = {
  name: string,
  values?: ?$ReadOnlyArray<?string>,
};
export type PageInfoInput = {
  limit?: ?number,
  offset?: ?number,
};
export type TrackContentQueryVariables = {|
  input?: ?VendorFilterInput
|};
export type TrackContentQueryResponse = {|
  +$fragmentRefs: TrackContent_queryResult$ref
|};
export type TrackContentQuery = {|
  variables: TrackContentQueryVariables,
  response: TrackContentQueryResponse,
|};
*/


/*
query TrackContentQuery(
  $input: VendorFilterInput
) {
  ...TrackContent_queryResult_2VV6jB
}

fragment TrackContent_queryResult_2VV6jB on Query {
  vendors_search(input: $input) {
    page_info {
      ...PaginationData_pageInfo
    }
    result {
      id
      logo_url
      ref_id
      name
      rating_count
      avg_rating
      follow
      followed
      track
      city {
        name
        id
      }
      country {
        name
        id
      }
      featured
      departments {
        id
        name
      }
      track_sub_departments {
        id
        name
        track_department_id
        ref_id
      }
    }
    related_sorts {
      name
      display_name
      selected
    }
    related_filters {
      display_name
      name
      options {
        selected
        count
        name
        value
        options {
          display_name
          name
          options {
            selected
            count
            name
            value
          }
        }
      }
    }
    errors {
      field
      messages
      code
    }
  }
}

fragment PaginationData_pageInfo on PageInfo {
  current_page
  items_count
  limit
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "VendorFilterInput",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = [
  v3,
  v1
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "display_name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "selected",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "TrackContentQuery",
  "id": null,
  "text": "query TrackContentQuery(\n  $input: VendorFilterInput\n) {\n  ...TrackContent_queryResult_2VV6jB\n}\n\nfragment TrackContent_queryResult_2VV6jB on Query {\n  vendors_search(input: $input) {\n    page_info {\n      ...PaginationData_pageInfo\n    }\n    result {\n      id\n      logo_url\n      ref_id\n      name\n      rating_count\n      avg_rating\n      follow\n      followed\n      track\n      city {\n        name\n        id\n      }\n      country {\n        name\n        id\n      }\n      featured\n      departments {\n        id\n        name\n      }\n      track_sub_departments {\n        id\n        name\n        track_department_id\n        ref_id\n      }\n    }\n    related_sorts {\n      name\n      display_name\n      selected\n    }\n    related_filters {\n      display_name\n      name\n      options {\n        selected\n        count\n        name\n        value\n        options {\n          display_name\n          name\n          options {\n            selected\n            count\n            name\n            value\n          }\n        }\n      }\n    }\n    errors {\n      field\n      messages\n      code\n    }\n  }\n}\n\nfragment PaginationData_pageInfo on PageInfo {\n  current_page\n  items_count\n  limit\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TrackContentQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "TrackContent_queryResult",
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TrackContentQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "vendors_search",
        "storageKey": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "VendorFilterInput"
          }
        ],
        "concreteType": "VendorsFilterResult",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "page_info",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "current_page",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "items_count",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "limit",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "result",
            "storageKey": null,
            "args": null,
            "concreteType": "Shop",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "followed",
                "args": null,
                "storageKey": null
              },
              v1,
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rating_count",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "avg_rating",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "follow",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "logo_url",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "track",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "city",
                "storageKey": null,
                "args": null,
                "concreteType": "State",
                "plural": false,
                "selections": v4
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "country",
                "storageKey": null,
                "args": null,
                "concreteType": "Country",
                "plural": false,
                "selections": v4
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "featured",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "departments",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackDepartment",
                "plural": true,
                "selections": [
                  v1,
                  v3
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "track_sub_departments",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackSubDepartment",
                "plural": true,
                "selections": [
                  v1,
                  v3,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "track_department_id",
                    "args": null,
                    "storageKey": null
                  },
                  v2
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "related_sorts",
            "storageKey": null,
            "args": null,
            "concreteType": "SortOption",
            "plural": true,
            "selections": [
              v3,
              v5,
              v6
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "related_filters",
            "storageKey": null,
            "args": null,
            "concreteType": "Search",
            "plural": true,
            "selections": [
              v5,
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "options",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchOption",
                "plural": true,
                "selections": [
                  v6,
                  v7,
                  v3,
                  v8,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "options",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OptionValueFilter",
                    "plural": false,
                    "selections": [
                      v5,
                      v3,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "options",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchOption",
                        "plural": true,
                        "selections": [
                          v6,
                          v7,
                          v3,
                          v8
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "errors",
            "storageKey": null,
            "args": null,
            "concreteType": "Error",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "field",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "messages",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "code",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f5be9e8284f0e549b5bf8929e0b3dc8e';
module.exports = node;
